/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.OutOfOfficeHoursRpc
 */

export const BaseChirpErrorDiscriminantKey = '@type';
export const ChirpContextErrorTypename = 'com.hubspot.cv.assignments.core.ChirpContextError';
export const ChirpContextErrorDiscriminant = 'ChirpContextError';
export const ChirpContextErrorDiscriminantKey = '@type';
export const RoutingExplanationErrorTypename = 'com.hubspot.cv.assignments.core.routing.explanation.RoutingExplanationError';
export const RoutingExplanationErrorDiscriminant = 'RoutingExplanationError';
export const RoutingExplanationErrorDiscriminantKey = '@type';
export const fetchOutOfOfficeStatusesRpc = {
  serviceName: 'com.hubspot.cv.assignments.rpc.OutOfOfficeHoursRpc',
  rpcName: 'fetchOutOfOfficeStatuses',
  auth: 'app',
  fingerprint: 'Qg1J590v3Kg4L-CYf-S5zAAP4KRZT-uF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};